import React from 'react';
import PlatformSchedulingManagement, { PlatformSchedulingManagementProps } from './PlatformSchedulingManagement';

const PlatformOrderingManagement: React.FC<PlatformSchedulingManagementProps> = (props) => (
    <PlatformSchedulingManagement {...props} vertical="ordering" />
);

export default PlatformOrderingManagement;
